import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, CheckCircle2Icon, ShoppingCartIcon, SparklesIcon, GiftIcon } from 'lucide-react';
import { initMetaPixel, trackInitiateCheckout, trackAddBonus, trackSkipBonus } from '../utils/metaPixel';
const notifications = [{
  name: 'Laura',
  action: 'acaba de añadir el Bono 1'
}, {
  name: 'Carlos',
  action: 'compró los Bonos 2 y 3'
}, {
  name: 'Ana',
  action: 'agregó los bonos a su pedido'
}, {
  name: 'Daniel',
  action: 'acaba de obtener el Bono 1'
}, {
  name: 'María',
  action: 'eligió el paquete de Bonos'
}, {
  name: 'Javier',
  action: 'añadió el Bono 1'
}, {
  name: 'Sofía',
  action: 'compró los Bonos 2 y 3'
}, {
  name: 'Andrés',
  action: 'acaba de añadir los bonos'
}, {
  name: 'Valentina',
  action: 'agregó el Bono 1'
}, {
  name: 'Ricardo',
  action: 'compró el paquete 2x1'
}];
const testimonials = [{
  name: 'Gabriela M.',
  text: 'Este material me ayudó a entender mis emociones y comenzar a sentirme mejor.'
}, {
  name: 'Fernando R.',
  text: 'Los ejercicios y el diario guiado fueron una herramienta increíble para mí.'
}, {
  name: 'Lucía C.',
  text: 'Muy práctico. Las herramientas realmente ayudan a calmar la mente.'
}, {
  name: 'Miguel A.',
  text: 'Una guía sencilla pero poderosa para mejorar el bienestar emocional.'
}];
export function UpsellPage() {
  const [bonus1Selected, setBonus1Selected] = useState(false);
  const [bonus23Selected, setBonus23Selected] = useState(false);
  const [activeNotification, setActiveNotification] = useState<(typeof notifications)[0] | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [missingBonus, setMissingBonus] = useState<'bonus1' | 'bonus23' | null>(null);
  const hasSelection = bonus1Selected || bonus23Selected;
  useEffect(() => {
    const showRandomNotification = () => {
      const randomNotif = notifications[Math.floor(Math.random() * notifications.length)];
      setActiveNotification(randomNotif);
      // Hide after 5 seconds
      setTimeout(() => {
        setActiveNotification(null);
      }, 5000);
    };
    // Initial delay before first notification
    const initialTimer = setTimeout(showRandomNotification, 5000);
    // Then every 35 seconds
    const interval = setInterval(showRandomNotification, 35000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  const getCheckoutUrl = (b1: boolean, b23: boolean) => {
    if (b1 && b23) return 'https://www.caminoalaluzguia.com/cart/51843759309102:1';
    if (b1) return 'https://www.caminoalaluzguia.com/cart/51843756294446:1';
    if (b23) return 'https://www.caminoalaluzguia.com/cart/51843757769006:1';
    return 'https://www.caminoalaluzguia.com/cart/51830446850350:1';
  };
  const handlePurchase = () => {
    if (!hasSelection) return;
    // Both selected → go straight to checkout
    if (bonus1Selected && bonus23Selected) {
      trackInitiateCheckout('Bono 1 + Bono 2&3', 18);
      window.open(getCheckoutUrl(true, true), '_blank');
      return;
    }
    // Only one selected → show modal for missing bonus
    if (bonus1Selected && !bonus23Selected) {
      trackInitiateCheckout('Bono 1', 9);
      setMissingBonus('bonus23');
      setShowModal(true);
    } else if (!bonus1Selected && bonus23Selected) {
      trackInitiateCheckout('Bono 2&3', 9);
      setMissingBonus('bonus1');
      setShowModal(true);
    }
  };
  const handleAddMissingAndBuy = () => {
    const finalB1 = missingBonus === 'bonus1' ? true : bonus1Selected;
    const finalB23 = missingBonus === 'bonus23' ? true : bonus23Selected;
    trackAddBonus(missingBonus === 'bonus1' ? 'Bono 1' : 'Bono 2&3');
    if (missingBonus === 'bonus1') setBonus1Selected(true);
    if (missingBonus === 'bonus23') setBonus23Selected(true);
    setShowModal(false);
    window.open(getCheckoutUrl(finalB1, finalB23), '_blank');
  };
  const handleSkipAndBuy = () => {
    trackSkipBonus();
    setShowModal(false);
    window.open(getCheckoutUrl(bonus1Selected, bonus23Selected), '_blank');
  };
  return <div className="min-h-screen font-sans text-slate-800 pb-20 overflow-x-hidden relative" data-id="element-274">
      {/* Background Image */}
      <div className="fixed inset-0 -z-10" data-id="element-275">
        <img src="https://cdn.magicpatterns.com/uploads/212JHeVCcQ5X1q2Y7Y9n84/13_mar_2026,_11_51_55_p.m..png" alt="" className="w-full h-full object-cover" data-id="element-276" />
        <div className="absolute inset-0 bg-[#fdf8f2]/80" data-id="element-277"></div>
      </div>
      {/* Floating Notification */}
      <AnimatePresence data-id="element-278">
        {activeNotification && <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} className="fixed bottom-6 left-4 right-4 md:left-auto md:right-6 md:w-80 bg-white rounded-2xl shadow-xl border border-[#e8d0a0] p-4 z-50 flex items-start gap-3" data-id="element-279">
            <div className="w-10 h-10 rounded-full bg-[#f5ede0] flex items-center justify-center flex-shrink-0" data-id="element-280">
              <CheckCircle2Icon className="w-5 h-5 text-[#c4893a]" data-id="element-281" />
            </div>
            <div data-id="element-282">
              <p className="text-sm font-bold text-slate-700" data-id="element-283">
                {activeNotification.name}
              </p>
              <p className="text-xs text-slate-500" data-id="element-284">
                {activeNotification.action}
              </p>
              <p className="text-[10px] text-slate-400 mt-1" data-id="element-285">
                Hace unos momentos
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* UPSELL MODAL */}
      <AnimatePresence data-id="element-286">
        {showModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] flex items-center justify-center px-4" style={{
        backgroundColor: 'rgba(30, 20, 10, 0.75)',
        backdropFilter: 'blur(4px)'
      }} data-id="element-287">
            <motion.div initial={{
          opacity: 0,
          scale: 0.85,
          y: 30
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} transition={{
          type: 'spring',
          damping: 20,
          stiffness: 300
        }} className="bg-white rounded-3xl shadow-2xl max-w-sm w-full overflow-hidden" data-id="element-288">
              {/* Modal Header — warm gradient */}
              <div className="bg-gradient-to-br from-[#c4893a] via-[#d4a870] to-[#e8c080] px-6 pt-8 pb-6 text-center relative overflow-hidden" data-id="element-289">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_var(--tw-gradient-stops))] from-white/20 to-transparent pointer-events-none" data-id="element-290"></div>
                <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3 relative z-10" data-id="element-291">
                  <GiftIcon className="w-7 h-7 text-white" data-id="element-292" />
                </div>
                <p className="text-white/80 text-xs font-bold uppercase tracking-widest mb-1 relative z-10" data-id="element-293">
                  ¡OFERTA EXCLUSIVA!
                </p>
                <h2 className="font-serif text-2xl font-bold text-white leading-tight relative z-10" data-id="element-294">
                  {missingBonus === 'bonus23' ? '¡Completa tu transformación!' : '¡No te quedes a medias!'}
                </h2>
              </div>

              {/* Modal Body */}
              <div className="px-6 py-6 text-center" data-id="element-295">
                <div className="bg-[#fdf8f2] rounded-2xl p-4 mb-5 border border-[#e8d0a0]" data-id="element-296">
                  <div className="flex items-center justify-center gap-2 mb-2" data-id="element-297">
                    <SparklesIcon className="w-4 h-4 text-[#c4893a]" data-id="element-298" />
                    <span className="text-xs font-bold text-[#c4893a] uppercase tracking-wider" data-id="element-299">
                      {missingBonus === 'bonus23' ? 'BONO 2 + BONO 3' : 'BONO 1'}
                    </span>
                  </div>
                  <p className="font-serif text-lg font-bold text-slate-800 mb-1" data-id="element-300">
                    {missingBonus === 'bonus23' ? 'Mindfulness + Plan De Acción' : 'Diario De Autoexploración Guiado'}
                  </p>
                  <p className="text-sm text-slate-500 leading-relaxed" data-id="element-301">
                    {missingBonus === 'bonus23' ? 'Aprende a calmar tu mente y establece metas que te impulsen hacia adelante.' : 'Entiende tus emociones, libera pensamientos y gana claridad interior.'}
                  </p>
                  <div className="flex items-center justify-center gap-2 mt-3" data-id="element-302">
                    <span className="text-sm text-slate-400 line-through" data-id="element-303">
                      {missingBonus === 'bonus23' ? 'Valor $98' : 'Valor $49'}
                    </span>
                    <span className="text-lg font-bold text-[#c4893a]" data-id="element-304">
                      Solo $9
                    </span>
                  </div>
                </div>

                <p className="text-slate-600 text-sm mb-5 leading-relaxed" data-id="element-305">
                  Muchas personas que compraron solo un bono volvieron a buscar
                  el otro.{' '}
                  <strong className="text-slate-700" data-id="element-306">
                    ¡Aprovecha ahora que está disponible!
                  </strong>
                </p>

                {/* Primary CTA */}
                <button onClick={handleAddMissingAndBuy} className="w-full bg-gradient-to-r from-[#c4893a] to-[#d4a870] text-white font-bold text-base py-4 rounded-2xl shadow-lg shadow-[#c4893a]/30 hover:scale-[1.02] transition-all flex items-center justify-center gap-2 mb-3" data-id="element-307">
                  <CheckCircle2Icon className="w-5 h-5" data-id="element-308" />
                  ¡Sí lo quiero! – Añadir por $9
                </button>

                {/* Skip link */}
                <button onClick={handleSkipAndBuy} className="text-xs text-slate-400 hover:text-slate-600 transition-colors underline underline-offset-2" data-id="element-309">
                  No gracias, continuar sin los bonos
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* 1. HEADER SECTION */}
      <header className="py-12 px-4 text-center max-w-2xl mx-auto" data-id="element-310">
        <span className="text-xs font-bold tracking-widest text-[#c4893a] uppercase mb-3 block" data-id="element-311">
          OFERTA ESPECIAL
        </span>
        <h1 className="font-serif text-3xl md:text-4xl font-bold text-slate-800 leading-tight mb-3" data-id="element-312">
          Potencia Tu Proceso De Sanación
        </h1>
        <p className="text-base text-slate-500 leading-relaxed" data-id="element-313">
          Herramientas prácticas para acompañar tu transformación emocional.
        </p>

        <div className="rounded-2xl bg-amber-50 border border-[#e8d0a0] px-6 py-3 mt-6 inline-block" data-id="element-314">
          <p className="text-sm text-slate-400 line-through mb-0.5" data-id="element-315">
            Valor original de cada bono: $49
          </p>
          <p className="text-lg font-bold text-[#c4893a]" data-id="element-316">
            Hoy puedes obtenerlos por solo $9
          </p>
        </div>
      </header>

      {/* 2. PRODUCT CARDS SECTION */}
      <section className="max-w-lg mx-auto px-4 flex flex-col gap-8" data-id="element-317">
        {/* BONO 1 CARD */}
        <div className={`relative rounded-3xl bg-white shadow-xl border-2 transition-all duration-300 pt-8 p-6 ${bonus1Selected ? 'border-[#c4893a] shadow-[#d4a870]/30' : 'border-[#e8d8c0]'}`} data-id="element-318">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-max" data-id="element-319">
            <div className="bg-gradient-to-r from-[#c4893a] to-[#d4a870] text-white text-xs font-bold px-4 py-1 rounded-full shadow-md" data-id="element-320">
              ⭐ ALTAMENTE RECOMENDADO ⭐
            </div>
          </div>

          {/* Product Image */}
          <div className="relative mx-auto mb-6 w-48 h-48 flex items-center justify-center" data-id="element-321">
            <div className="absolute -inset-4 bg-[#e8d0a0]/30 rounded-3xl blur-2xl -z-10" data-id="element-322"></div>
            <img src="https://cdn.magicpatterns.com/uploads/iHHiwJ9611qkZ5fGGpConv/ChatGPT_Image_13_mar_2026,_02_53_19_p.m..png" alt="Diario de Autoexploración Guiado - Bono 1" className="w-full h-full object-cover rounded-2xl shadow-xl shadow-[#c4893a]/20" data-id="element-323" />
          </div>

          <div className="text-center mb-5" data-id="element-324">
            <p className="text-xs font-bold tracking-widest text-[#c4893a] uppercase mb-1" data-id="element-325">
              BONO 1
            </p>
            <h3 className="font-serif text-xl font-bold text-slate-800 mb-2" data-id="element-326">
              Diario De Autoexploración Guiado
            </h3>
            <p className="text-sm text-slate-500 leading-relaxed" data-id="element-327">
              Un diario guiado para ayudarte a entender tus emociones, liberar
              pensamientos y ganar claridad interior.
            </p>
          </div>

          <div className="flex items-center justify-center gap-2 mb-5" data-id="element-328">
            <span className="text-sm text-slate-400 line-through" data-id="element-329">
              Antes $49
            </span>
            <span className="text-lg font-bold text-[#c4893a]" data-id="element-330">Hoy $9</span>
          </div>

          <button onClick={() => setBonus1Selected(!bonus1Selected)} className={`w-full rounded-2xl py-4 font-bold text-base transition-all flex items-center justify-center gap-2.5 ${bonus1Selected ? 'bg-gradient-to-r from-[#c4893a] to-[#d4a870] text-white shadow-lg shadow-[#c4893a]/30 scale-[1.01]' : 'bg-gradient-to-r from-[#c4893a] to-[#d4a870] text-white shadow-md shadow-[#c4893a]/20 hover:shadow-lg hover:shadow-[#c4893a]/30 hover:scale-[1.02] opacity-90 hover:opacity-100'}`} data-id="element-331">
            {bonus1Selected ? <>
                <CheckCircle2Icon className="w-5 h-5" data-id="element-332" />
                ¡Bono 1 Añadido! – $9
              </> : <>
                <ShoppingCartIcon className="w-5 h-5" data-id="element-333" />☐ Añadir Bono 1 – $9
              </>}
          </button>
        </div>

        {/* BONO 2+3 CARD */}
        <div className={`relative rounded-3xl bg-white shadow-xl border-2 transition-all duration-300 pt-8 p-6 ${bonus23Selected ? 'border-[#c4893a] shadow-[#d4a870]/30' : 'border-[#e8d8c0]'}`} data-id="element-334">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-max" data-id="element-335">
            <div className="bg-gradient-to-r from-[#c4893a] to-[#d4a870] text-white text-xs font-bold px-4 py-1 rounded-full shadow-md" data-id="element-336">
              ⭐ ALTAMENTE RECOMENDADO ⭐
            </div>
          </div>

          {/* Product Images (Two Books) */}
          <div className="flex gap-3 justify-center mb-6" data-id="element-337">
            <div className="relative w-[47%]" data-id="element-338">
              <div className="absolute -inset-2 bg-[#e8d0a0]/20 rounded-2xl blur-xl -z-10" data-id="element-339"></div>
              <img src="https://cdn.magicpatterns.com/uploads/fHZZz3mVMrxRL94t7BkzES/ChatGPT_Image_13_mar_2026,_02_54_19_p.m..png" alt="Guía De Mindfulness Para Principiantes - Bono 2" className="w-full rounded-2xl shadow-lg shadow-[#7ab0c8]/20 object-cover" data-id="element-340" />
            </div>
            <div className="relative w-[47%]" data-id="element-341">
              <div className="absolute -inset-2 bg-[#e8d0a0]/20 rounded-2xl blur-xl -z-10" data-id="element-342"></div>
              <img src="https://cdn.magicpatterns.com/uploads/mxwjDW6eubWUZ31gatKHWb/ChatGPT_Image_13_mar_2026,_02_55_37_p.m..png" alt="Plan De Acción Para Establecer Metas - Bono 3" className="w-full rounded-2xl shadow-lg shadow-[#a0c8b0]/20 object-cover" data-id="element-343" />
            </div>
          </div>

          <div className="text-center mb-4" data-id="element-344">
            <p className="text-xs font-bold tracking-widest text-[#c4893a] uppercase mb-1" data-id="element-345">
              BONO 2 + BONO 3
            </p>
            <h3 className="font-serif text-xl font-bold text-slate-800 mb-3" data-id="element-346">
              Mindfulness + Plan De Acción
            </h3>
            <div className="space-y-1.5" data-id="element-347">
              <p className="text-sm text-slate-500" data-id="element-348">
                BONO 2 — Guía De Mindfulness Para Principiantes
              </p>
              <p className="text-sm text-slate-500" data-id="element-349">
                BONO 3 — Plan De Acción Para Establecer Metas
              </p>
            </div>
          </div>

          <div className="bg-[#f0f8f0] rounded-xl p-3 mt-4 mb-5 text-center border border-[#d8e8d8]" data-id="element-350">
            <p className="text-sm text-slate-400 line-through mb-0.5" data-id="element-351">
              Valor original: $98
            </p>
            <p className="text-base font-bold text-[#7a9e6a]" data-id="element-352">
              Hoy 2x1 por solo $9
            </p>
          </div>

          <button onClick={() => setBonus23Selected(!bonus23Selected)} className={`w-full rounded-2xl py-4 font-bold text-base transition-all flex items-center justify-center gap-2.5 ${bonus23Selected ? 'bg-gradient-to-r from-[#c4893a] to-[#d4a870] text-white shadow-lg shadow-[#c4893a]/30 scale-[1.01]' : 'bg-gradient-to-r from-[#c4893a] to-[#d4a870] text-white shadow-md shadow-[#c4893a]/20 hover:shadow-lg hover:shadow-[#c4893a]/30 hover:scale-[1.02] opacity-90 hover:opacity-100'}`} data-id="element-353">
            {bonus23Selected ? <>
                <CheckCircle2Icon className="w-5 h-5" data-id="element-354" />
                ¡Bonos 2 y 3 Añadidos! – $9
              </> : <>
                <ShoppingCartIcon className="w-5 h-5" data-id="element-355" />☐ Añadir Bonos 2 y 3 –
                $9
              </>}
          </button>
        </div>
      </section>

      {/* 3. PURCHASE BUTTON + SKIP */}
      <section className="max-w-lg mx-auto px-4 mt-10 text-center" data-id="element-356">
        <button onClick={handlePurchase} disabled={!hasSelection} className={`w-full block rounded-full py-4 font-bold text-lg transition-all ${hasSelection ? 'bg-gradient-to-r from-[#c4893a] to-[#d4a870] text-white shadow-lg shadow-[#c4893a]/30 hover:scale-[1.02]' : 'bg-slate-200 text-slate-400 cursor-not-allowed'}`} data-id="element-357">
          Añadir Bonos A Mi Compra
        </button>

        <a href="https://www.caminoalaluzguia.com/cart/51830446850350:1" target="_blank" rel="noopener noreferrer" className="inline-block mt-6 text-sm text-slate-400 hover:text-slate-600 transition-colors underline decoration-slate-300 underline-offset-4" data-id="element-358">
          No gracias, continuar sin los bonos
        </a>
      </section>

      {/* TESTIMONIALS SECTION */}
      <section className="max-w-3xl mx-auto px-4 mt-20" data-id="element-359">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-360">
          {testimonials.map((t, i) => <div key={i} className="bg-white rounded-2xl p-5 shadow-sm border border-[#e8d8c0]" data-id="element-361">
              <div className="flex items-center gap-1 mb-3" data-id="element-362">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-4 h-4 fill-[#c4893a] text-[#c4893a]" data-id="element-363" />)}
              </div>
              <p className="text-slate-600 text-sm leading-relaxed mb-3 italic" data-id="element-364">
                "{t.text}"
              </p>
              <p className="text-xs font-bold text-slate-800" data-id="element-365">{t.name}</p>
            </div>)}
        </div>
      </section>

      {/* FOOTER */}
      <footer className="max-w-lg mx-auto px-4 mt-8 text-center pb-4" data-id="element-366"></footer>
    </div>;
}